import React from 'react';

const ConfirmationModal = ({ onCancel, onConfirm, customerName }) => {
    return (
        <div className="modal-overlay">
            <div className="modal-content confirmation-modal">
                <h3>Delete Customer</h3>
                <p>Are you sure you want to delete the customer: <strong>{customerName}</strong>? This action cannot be undone.</p>
                <div className="modal-actions">
                    <button type="button" className="cancel-btn" onClick={onCancel}>Cancel</button>
                    <button type="button" className="confirm-btn danger" onClick={onConfirm}>Delete</button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
